import {
  gameIdsByLicensedTerritory,
  type LicensedTerritory,
} from '@lottocom/high-frequency-game-mapping'

const territoryByGameId = new Map<string, LicensedTerritory>(
  Object.entries(gameIdsByLicensedTerritory).flatMap(([territory, gameIds]) =>
    gameIds.map((gameId) => [gameId, territory as LicensedTerritory] as const),
  ),
)

export const licensedTerritoryForGameId = (gameId?: string): LicensedTerritory | undefined =>
  gameId ? territoryByGameId.get(gameId) : undefined
